import { API_BASE, CREDENTIALS, POST_HEADERS } from 'constants/apis';
import deserializer from 'utils/jsonapi-serializer/deserializer';
import errorParser from 'utils/jsonapi-serializer/errorParser';

export const getData = async (url: string) => {
  try {
    const res = await fetch(url, {
      credentials: CREDENTIALS,
    });
    const resJson = await res.json();
    if (resJson.errors)
      return {
        error: errorParser(resJson),
        newXCSRFToken: res.headers.get('x-csrf-token'),
      };
    const resDeserializer = await deserializer(resJson);
    return {
      payload: resDeserializer,
      newXCSRFToken: res.headers.get('x-csrf-token'),
      dataSize: resJson.meta,
    };
  } catch (error) {
    return { error };
  }
};

export const postData = async (url: string, body: string, xCSRFToken: string) => {
  try {
    const res = await fetch(url, {
      credentials: CREDENTIALS,
      method: 'POST',
      headers: POST_HEADERS(xCSRFToken),
      body,
    });
    const resJson = await res.json();
    if (resJson.errors)
      return {
        error: errorParser(resJson),
        newXCSRFToken: res.headers.get('x-csrf-token'),
      };
    const resDeserializer = await deserializer(resJson);
    return {
      payload: resDeserializer,
      newXCSRFToken: res.headers.get('x-csrf-token'),
    };
  } catch (error) {
    return { error };
  }
};

export const patchData = async (url: string, body: string, xCSRFToken: string) => {
  try {
    const res = await fetch(url, {
      credentials: CREDENTIALS,
      method: 'PATCH',
      headers: POST_HEADERS(xCSRFToken),
      body,
    });
    const resJson = await res.json();
    if (resJson.errors)
      return {
        error: errorParser(resJson),
        newXCSRFToken: res.headers.get('x-csrf-token'),
      };
    const resDeserializer = await deserializer(resJson);
    return {
      payload: resDeserializer,
      newXCSRFToken: res.headers.get('x-csrf-token'),
    };
  } catch (error) {
    return { error };
  }
};

export const deleteData = async (url: string, xCSRFToken: string) => {
  try {
    const res = await fetch(url, {
      credentials: CREDENTIALS,
      method: 'DELETE',
      headers: POST_HEADERS(xCSRFToken),
    });
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return {
      payload: 'success',
      newXCSRFToken: res.headers.get('x-csrf-token'),
    };
  } catch (error) {
    return { error };
  }
};

export const requestFetchXCSRFToken = async () => {
  const url = `${API_BASE}/csrf_token`;
  try {
    const res = await fetch(url, { credentials: CREDENTIALS });
    return {
      payload: { status: res.status },
      newXCSRFToken: res.headers.get('x-csrf-token'),
    };
  } catch (error) {
    return { error };
  }
};
